import React, { useMemo } from 'react'
import { WithTreeIds } from '../navigationHelpers/WithTree'
import { Box } from '@mui/material'
import { UPVideos } from './UPVideos/UPVideos'
import { TreeManagementToolSelect } from 'shared/ui'
import { AddAudioFilesForEL } from '../AddAudioFilesForEL/AddAudioFilesForEL'

export function OneOffToolsWrapper() {
  return <WithTreeIds Wrapped={OneOffTools} />
}

const oneOffTools = [
  { title: 'UP Videos', Comp: UPVideos },
  { title: 'EL Audio Files', Comp: AddAudioFilesForEL },
]

function useTreeTools({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return useMemo(() => {
    return oneOffTools.map(({ title, Comp }) => {
      return {
        title,
        component: () => (
          <Comp key={title} treeId={treeId} versionId={versionId} />
        ),
      }
    })
  }, [treeId, versionId])
}

function OneOffTools(ids: { treeId: string; versionId: string }) {
  const componentOptions = useTreeTools(ids)

  return (
    <Box>
      <Box>Select Tree Tool</Box>
      <TreeManagementToolSelect components={componentOptions} />
    </Box>
  )
}
